import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import CompanionFooter from './CompanionFooter';
import QuizMeQuestions from './QuizMeQuestions';
import { MOCK_QUIZ_ME_DATA } from '../mockData';
import { RightIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const QuizMeTab = () => {
  const [questionIndex, setQuestionIndex] = useState(0);
  const [selectedAnswerIndex, setSelectedAnswerIndex] = useState();
  const [questionAnswered, setQuestionAnswered] = useState(false);
  const handleQuestionIndexChange = index => setQuestionIndex(index);
  const handleSelectAnswerIndexChange = answerIndex => setSelectedAnswerIndex(answerIndex);
  const handleCheckAnswer = () => setQuestionAnswered(true);
  const handleNext = () => {
    setQuestionIndex(prev => prev + 1);
    setSelectedAnswerIndex(undefined);
    setQuestionAnswered(false);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      paddingBlockStart: "700",
      paddingInline: "700",
      children: /*#__PURE__*/_jsx(QuizMeQuestions, {
        handleQuestionIndexChange: handleQuestionIndexChange,
        handleSelectAnswerIndexChange: handleSelectAnswerIndexChange,
        questionAnswered: questionAnswered,
        questionIndex: questionIndex
        // TODO: Dummy data for initial implementation
        ,
        quizQuestions: MOCK_QUIZ_ME_DATA,
        selectedAnswerIndex: selectedAnswerIndex
      })
    }), /*#__PURE__*/_jsx(CompanionFooter, {
      additionalButtons: /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [!questionAnswered && selectedAnswerIndex !== undefined && /*#__PURE__*/_jsxs(Button, {
          onClick: handleCheckAnswer,
          use: "tertiary",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.interactiveEducation.quiz.checkAnswer"
          }), /*#__PURE__*/_jsx(RightIcon, {})]
        }), questionAnswered && /*#__PURE__*/_jsxs(Button, {
          onClick: handleNext,
          use: "tertiary",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.interactiveEducation.quiz.next"
          }), /*#__PURE__*/_jsx(RightIcon, {})]
        })]
      })
    })]
  });
};
export default QuizMeTab;